import { cn } from "@/lib/utils";
import { Button, type ButtonProps } from "./button";

const SHAPE =
  "h-[29px] gap-1 rounded-tip border-[1.5px] border-success px-[13px] text-[11.5px] font-extrabold tracking-[0.01em] disabled:opacity-40 [&_svg]:size-3.5";

/**
 * The attorney's yes on one thing, and the way to take it back.
 *
 * Not one of `Button`'s variants, because it is a state as well as an act: the
 * design draws a yes not yet given as a green outline on white, and a yes given
 * as the filled green, and the same control moves between them. A reader hears
 * which through `aria-pressed`.
 */
export function ConfirmButton({
  confirmed,
  className,
  children,
  ...rest
}: Omit<ButtonProps, "variant" | "size" | "aria-pressed"> & {
  confirmed: boolean;
}) {
  return (
    <Button
      type="button"
      variant="confirm"
      aria-pressed={confirmed}
      className={cn(
        SHAPE,
        confirmed
          ? "shadow-none"
          : "bg-card text-success-strong shadow-confirm hover:bg-success-surface hover:brightness-100",
        className,
      )}
      {...rest}
    >
      {children}
    </Button>
  );
}
